import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import TheStudiosSoul from "./sections/TheStudiosSoul";
import OnzeReparatiediensten from "./sections/OnzeReparatiediensten";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <TheStudiosSoul />
      <OnzeReparatiediensten />
      <Footer />
    </div>;
}